import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["navLink"];
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import get from "lodash/get";
import omit from "lodash/omit";
export var removeNavLinkIcon = function (_ref) {
  var navLink = _ref.navLink,
    rest = _objectWithoutProperties(_ref, _excluded);
  return navLink ? _objectSpread(_objectSpread({}, rest), {}, {
    navLink: omit(navLink, "icon")
  }) : rest;
};
export var shouldShowIcons = function (routes) {
  var showOnNavBarRoutes = _filterInstanceProperty(routes).call(routes, function (route) {
    return get(route, "showOnNavBar", !0);
  });
  return showOnNavBarRoutes.every(function (_ref2) {
    return _ref2.navLink;
  }) && showOnNavBarRoutes.every(function (_ref3) {
    return _ref3.navLink.icon;
  });
};